export enum BopisStoreLogo {
	DICKSSPORTINGGOODS = 'assets/image/store_pickup.svg',
    GOLFGALAXY = 'assets/image/GG_pickup_logo.svg',
    PUBLICLANDS = 'assets/image/pl_bopis_logo.svg',
    UNKNOWN = 'UNKNOWN'
}
